export default __webpack_public_path__ + "static/media/sacrificial_bow.804b7a38.png";